import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserShift = createAsyncThunk(
    '/add/addUserShift',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-shift`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserShift = response.data;
            // console.log(addUserShift, '@@@')

            if (addUserShift.success === true) {
                toast.success(addUserShift?.message);
                return addUserShift;
            } else {
                // console.log(addUserShift.message, "&&&&")
                throw new Error(addUserShift.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserShiftSlice = createSlice({
    name: "addUserShift",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserShift.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserShift.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserShift.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserShiftSlice.reducer;